/* ==========================================================================
   GetTheCubes rebuild: shared theme behaviours (vanilla JS, no dependencies)
   - Scroll reveal (framer-motion replacement)      [data-reveal], [data-reveal-stagger]
   - Accordions                                     [data-ref-accordion]
   - Sheets / drawers                               [data-ref-sheet], [data-ref-sheet-open], [data-ref-sheet-close]
   - Dropdowns                                      [data-ref-dropdown]
   - AJAX cart + cart drawer                        RefTheme.cart
   - Checkout overlay                               RefTheme.checkout()
   - Smooth scroll to anchor                        [data-scroll-to]
   ========================================================================== */
(function () {
  'use strict';

  var RT = (window.RefTheme = window.RefTheme || {});
  var doc = document;
  var root = doc.documentElement;

  /* ---------------------------------------------------------------- money */
  RT.formatMoney = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || RT.moneyFormat || '${{amount}}';
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var m = formatString.match(placeholderRegex);
    switch (m && m[1]) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  };
  /* Whole-unit money (used for "Save $20" style labels) */
  RT.formatMoneyWhole = function (cents) {
    var f = (RT.moneyFormat || '${{amount}}').replace(/\{\{\s*amount\w*\s*\}\}/, '{{amount_no_decimals}}');
    return RT.formatMoney(Math.round(cents / 100) * 100, f);
  };

  /* ---------------------------------------------------------------- reveal */
  function setRevealVars(el) {
    var d = el.dataset;
    if (d.revealY != null) el.style.setProperty('--rv-y', d.revealY + 'px');
    if (d.revealX != null) el.style.setProperty('--rv-x', d.revealX + 'px');
    if (d.revealScale != null) el.style.setProperty('--rv-s', d.revealScale);
    if (d.revealRotate != null) el.style.setProperty('--rv-r', d.revealRotate + 'deg');
    if (d.revealOpacity != null) el.style.setProperty('--rv-o', d.revealOpacity);
    if (d.revealBlur != null) el.style.setProperty('--rv-filter', 'blur(' + d.revealBlur + 'px)');
    if (d.revealDuration != null) el.style.setProperty('--rv-d', d.revealDuration + 's');
    if (d.revealEase != null) el.style.setProperty('--rv-ease', d.revealEase);
    if (d.revealDelay != null && !el.style.getPropertyValue('--rv-delay')) el.style.setProperty('--rv-delay', d.revealDelay + 's');
  }
  function revealGroup(parent) {
    var stagger = parseFloat(parent.dataset.revealStagger) || 0;
    var start = parseFloat(parent.dataset.revealDelayChildren) || 0;
    var kids = Array.prototype.filter.call(parent.querySelectorAll('[data-reveal]'), function (k) {
      return k.closest('[data-reveal-stagger]') === parent && !k.hasAttribute('data-reveal-self');
    });
    kids.forEach(function (k, i) {
      var own = parseFloat(k.dataset.revealDelay) || 0;
      k.style.setProperty('--rv-delay', (start + i * stagger + own) + 's');
      k.classList.add('is-revealed');
    });
    if (parent.hasAttribute('data-reveal')) parent.classList.add('is-revealed');
  }
  var revealObservers = {};
  function getObserver(margin, amount) {
    var key = margin + '|' + amount;
    if (revealObservers[key]) return revealObservers[key];
    revealObservers[key] = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        obs.unobserve(el);
        if (el.hasAttribute('data-reveal-stagger')) revealGroup(el);
        else el.classList.add('is-revealed');
      });
    }, { rootMargin: margin, threshold: amount });
    return revealObservers[key];
  }
  RT.initReveal = function (scope) {
    scope = scope || doc;
    var els = scope.querySelectorAll('[data-reveal], [data-reveal-stagger]');
    els.forEach(function (el) { if (el.hasAttribute('data-reveal')) setRevealVars(el); });
    if (!('IntersectionObserver' in window) || root.classList.contains('shopify-design-mode')) {
      els.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }
    els.forEach(function (el) {
      if (el.__rvInit) return;
      el.__rvInit = true;
      var inGroup = el.parentElement && el.parentElement.closest('[data-reveal-stagger]');
      if (el.hasAttribute('data-reveal') && !el.hasAttribute('data-reveal-stagger') && inGroup && !el.hasAttribute('data-reveal-self')) return;
      if (el.hasAttribute('data-reveal-immediate')) {
        requestAnimationFrame(function () { requestAnimationFrame(function () {
          if (el.hasAttribute('data-reveal-stagger')) revealGroup(el); else el.classList.add('is-revealed');
        }); });
        return;
      }
      var margin = el.dataset.revealMargin || '-80px 0px -80px 0px';
      var amount = el.dataset.revealAmount != null ? parseFloat(el.dataset.revealAmount) : 0;
      getObserver(margin, amount).observe(el);
    });
  };

  /* ---------------------------------------------------------------- accordion */
  function setPanel(item, open, animate) {
    var panel = null;
    for (var i = 0; i < item.children.length; i++) {
      if (item.children[i].hasAttribute('data-acc-panel')) { panel = item.children[i]; break; }
    }
    var trigger = item.querySelector('[data-acc-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!panel) { open ? item.setAttribute('data-open', '') : item.removeAttribute('data-open'); return; }
    if (!animate) {
      if (open) { item.setAttribute('data-open', ''); panel.style.height = 'auto'; panel.style.opacity = '1'; }
      else { item.removeAttribute('data-open'); panel.style.height = '0px'; panel.style.opacity = '0'; }
      return;
    }
    if (open) {
      item.setAttribute('data-open', '');
      panel.style.height = '0px'; panel.style.opacity = '0';
      var h = panel.scrollHeight;
      requestAnimationFrame(function () {
        panel.style.height = h + 'px'; panel.style.opacity = '1';
      });
      var done = function (e) { if (e.propertyName !== 'height') return; panel.removeEventListener('transitionend', done); if (item.hasAttribute('data-open')) panel.style.height = 'auto'; };
      panel.addEventListener('transitionend', done);
    } else {
      panel.style.height = panel.scrollHeight + 'px';
      requestAnimationFrame(function () {
        item.removeAttribute('data-open');
        panel.style.height = '0px'; panel.style.opacity = '0';
      });
    }
  }
  RT.initAccordions = function (scope) {
    (scope || doc).querySelectorAll('[data-ref-accordion]').forEach(function (acc) {
      if (acc.__accInit) return;
      acc.__accInit = true;
      var items = Array.prototype.filter.call(acc.querySelectorAll('[data-acc-item]'), function (it) { return it.closest('[data-ref-accordion]') === acc; });
      items.forEach(function (it) {
        if (it.dataset.accRotate) it.style.setProperty('--acc-rotate', it.dataset.accRotate + 'deg');
        else if (acc.dataset.accRotate) it.style.setProperty('--acc-rotate', acc.dataset.accRotate + 'deg');
        setPanel(it, it.hasAttribute('data-open'), false);
        var trig = it.querySelector('[data-acc-trigger]');
        if (!trig) return;
        trig.addEventListener('click', function (ev) {
          ev.preventDefault();
          var willOpen = !it.hasAttribute('data-open');
          if (willOpen && !acc.hasAttribute('data-multiple')) {
            items.forEach(function (o) { if (o !== it && o.hasAttribute('data-open')) setPanel(o, false, true); });
          }
          setPanel(it, willOpen, true);
          acc.dispatchEvent(new CustomEvent('ref:accordion', { bubbles: true, detail: { item: it, open: willOpen, index: items.indexOf(it) } }));
        });
      });
    });
  };

  /* ---------------------------------------------------------------- scroll lock */
  var lockCount = 0, lockY = 0;
  RT.lockScroll = function () {
    if (lockCount++ > 0) return;
    lockY = window.scrollY;
    var b = doc.body;
    b.style.position = 'fixed'; b.style.top = '-' + lockY + 'px'; b.style.width = '100%';
    root.classList.add('ref-scroll-lock');
  };
  RT.unlockScroll = function () {
    if (--lockCount > 0) return;
    lockCount = 0;
    var b = doc.body;
    b.style.position = ''; b.style.top = ''; b.style.width = '';
    root.classList.remove('ref-scroll-lock');
    window.scrollTo(0, lockY);
  };

  /* ---------------------------------------------------------------- sheets */
  RT.openSheet = function (id) {
    var s = doc.getElementById(id);
    if (!s || s.getAttribute('data-state') === 'open') return;
    s.classList.remove('is-closing');
    s.setAttribute('data-state', 'open');
    s.setAttribute('aria-hidden', 'false');
    RT.lockScroll();
    var focusable = s.querySelector('[data-autofocus]') || s.querySelector('.ref-sheet__panel');
    if (focusable) setTimeout(function () { try { focusable.focus({ preventScroll: true }); } catch (e) {} }, 50);
    s.dispatchEvent(new CustomEvent('ref:sheet:open', { bubbles: true }));
  };
  RT.closeSheet = function (id) {
    var s = typeof id === 'string' ? doc.getElementById(id) : id;
    if (!s || s.getAttribute('data-state') !== 'open') return;
    s.setAttribute('data-state', 'closed');
    s.setAttribute('aria-hidden', 'true');
    s.classList.add('is-closing');
    setTimeout(function () { s.classList.remove('is-closing'); }, 320);
    RT.unlockScroll();
    s.dispatchEvent(new CustomEvent('ref:sheet:close', { bubbles: true }));
  };
  doc.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-ref-sheet-open]');
    if (opener) { e.preventDefault(); RT.openSheet(opener.getAttribute('data-ref-sheet-open')); return; }
    var closer = e.target.closest('[data-ref-sheet-close]');
    if (closer) {
      var sheet = closer.closest('.ref-sheet');
      if (closer.tagName === 'A' && closer.getAttribute('href') && closer.getAttribute('href').charAt(0) !== '#') { if (sheet) RT.closeSheet(sheet); return; }
      e.preventDefault(); if (sheet) RT.closeSheet(sheet);
    }
  });
  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    doc.querySelectorAll('.ref-sheet[data-state="open"]').forEach(function (s) { RT.closeSheet(s); });
    doc.querySelectorAll('[data-ref-dropdown][data-state="open"]').forEach(function (d) { d.setAttribute('data-state', 'closed'); });
  });

  /* ---------------------------------------------------------------- dropdowns */
  doc.addEventListener('click', function (e) {
    var trig = e.target.closest('[data-ref-dropdown-trigger]');
    doc.querySelectorAll('[data-ref-dropdown][data-state="open"]').forEach(function (d) {
      if (!trig || d !== trig.closest('[data-ref-dropdown]')) d.setAttribute('data-state', 'closed');
    });
    if (trig) {
      e.preventDefault();
      var dd = trig.closest('[data-ref-dropdown]');
      var open = dd.getAttribute('data-state') === 'open';
      dd.setAttribute('data-state', open ? 'closed' : 'open');
      trig.setAttribute('aria-expanded', open ? 'false' : 'true');
    }
  });
  /* Country selector: submit localization form */
  doc.addEventListener('click', function (e) {
    var opt = e.target.closest('[data-country-option]');
    if (!opt) return;
    e.preventDefault();
    var form = opt.closest('form');
    if (!form) return;
    form.querySelector('input[name="country_code"]').value = opt.getAttribute('data-country-option');
    form.submit();
  });

  /* ---------------------------------------------------------------- smooth scroll */
  doc.addEventListener('click', function (e) {
    var a = e.target.closest('[data-scroll-to]');
    if (!a) return;
    var sel = a.getAttribute('data-scroll-to') || a.getAttribute('href');
    var target = sel && sel.charAt(0) === '#' ? doc.querySelector(sel) : null;
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: a.getAttribute('data-scroll-block') || 'start' });
  });

  /* ---------------------------------------------------------------- cart */
  var cartSectionId = 'ref-cart-drawer';
  function json(url, opts) {
    return fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin' }, opts || {}))
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) { var err = new Error(d.description || d.message || 'Cart error'); err.data = d; throw err; } return d; }); });
  }
  function withSections(body) {
    body = body || {};
    body.sections = [cartSectionId];
    body.sections_url = window.location.pathname;
    return body;
  }
  RT.cart = {
    get: function () { return json((RT.routes.cart || '/cart') + '.js'); },
    add: function (items, opts) {
      opts = opts || {};
      return json((RT.routes.cartAdd || '/cart/add') + '.js', { method: 'POST', body: JSON.stringify(withSections({ items: items })) })
        .then(function (res) { return RT.cart.refresh(res.sections).then(function (cart) { if (opts.open !== false) RT.openSheet('RefCartDrawer'); return cart; }); });
    },
    change: function (key, quantity) {
      return json((RT.routes.cartChange || '/cart/change') + '.js', { method: 'POST', body: JSON.stringify(withSections({ id: key, quantity: quantity })) })
        .then(function (res) { return RT.cart.refresh(res.sections, res); });
    },
    update: function (updates) {
      return json((RT.routes.cartUpdate || '/cart/update') + '.js', { method: 'POST', body: JSON.stringify(withSections({ updates: updates })) })
        .then(function (res) { return RT.cart.refresh(res.sections, res); });
    },
    clear: function () { return json((RT.routes.cartClear || '/cart/clear') + '.js', { method: 'POST', body: '{}' }); },
    refresh: function (sections, cart) {
      var p = sections && sections[cartSectionId] ? Promise.resolve(sections[cartSectionId])
        : fetch(window.location.pathname + '?sections=' + cartSectionId, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (d) { return d[cartSectionId]; });
      return p.then(function (html) {
        if (html) {
          var tmp = doc.createElement('div'); tmp.innerHTML = html;
          var fresh = tmp.querySelector('[data-cart-drawer-inner]');
          var cur = doc.querySelector('[data-cart-drawer-inner]');
          if (fresh && cur) cur.replaceWith(fresh);
        }
        return cart ? cart : RT.cart.get();
      }).then(function (c) {
        doc.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = c.item_count;
          el.hidden = c.item_count === 0;
          el.classList.toggle('hidden', c.item_count === 0);
        });
        doc.dispatchEvent(new CustomEvent('ref:cart:updated', { detail: { cart: c } }));
        return c;
      });
    }
  };

  /* Bundle-aware cart line controls (rendered by sections/ref-cart-drawer.liquid) */
  var busy = false;
  function setBusy(v) {
    busy = v;
    doc.querySelectorAll('[data-cart-drawer-inner]').forEach(function (el) { el.toggleAttribute('data-loading', v); });
  }
  doc.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-action]');
    if (!btn || busy) return;
    e.preventDefault();
    var action = btn.getAttribute('data-cart-action');
    var key = btn.getAttribute('data-line-key');
    var group = btn.getAttribute('data-bundle-group');
    setBusy(true);
    var p;
    if (action === 'qty') {
      p = RT.cart.change(key, parseInt(btn.getAttribute('data-qty'), 10));
    } else if (action === 'remove') {
      p = group ? RT.cart.removeGroup(group) : RT.cart.change(key, 0);
    } else if (action === 'remove-line') {
      p = RT.cart.change(key, 0);
    } else if (action === 'tier') {
      p = RT.cart.switchTier(group, btn.getAttribute('data-target-variant'), btn.getAttribute('data-target-gifts'));
    } else if (action === 'checkout') {
      setBusy(false);
      RT.checkout();
      return;
    }
    Promise.resolve(p).catch(function (err) { console.error(err); }).then(function () { setBusy(false); });
  });

  /* Remove every line that belongs to a bundle group (paid line + its free gifts) */
  RT.cart.removeGroup = function (group) {
    return RT.cart.get().then(function (cart) {
      var updates = {};
      cart.items.forEach(function (it) {
        var g = it.properties && (it.properties._bundle_group || it.properties._gift_for);
        if (g === group) updates[it.key] = 0;
      });
      return RT.cart.update(updates);
    });
  };
  /* Swap a tiered bundle for another tier: remove the group, add the new variant + its gifts */
  RT.cart.switchTier = function (group, variantId, giftsCsv) {
    return RT.cart.get().then(function (cart) {
      var paid = null, updates = {};
      cart.items.forEach(function (it) {
        var g = it.properties && (it.properties._bundle_group || it.properties._gift_for);
        if (g === group) { updates[it.key] = 0; if (!it.properties._gift_for) paid = it; }
      });
      var props = paid ? Object.assign({}, paid.properties) : { _bundle_group: group };
      var items = [{ id: parseInt(variantId, 10), quantity: 1, properties: props }];
      if (paid && paid.selling_plan_allocation) items[0].selling_plan = paid.selling_plan_allocation.selling_plan.id;
      (giftsCsv || '').split(',').filter(Boolean).forEach(function (gid) {
        items.push({ id: parseInt(gid, 10), quantity: 1, properties: { _gift_for: group, _free_gift: 'Free Gift' } });
      });
      return json((RT.routes.cartUpdate || '/cart/update') + '.js', { method: 'POST', body: JSON.stringify({ updates: updates }) })
        .then(function () { return RT.cart.add(items, { open: false }); });
    });
  };

  /* ---------------------------------------------------------------- checkout */
  RT.checkout = function (itemsToReplaceCart) {
    var overlay = doc.querySelector('[data-checkout-overlay]');
    if (overlay) overlay.classList.add('is-active');
    var go = function () { window.location.href = (RT.routes.root || '/').replace(/\/$/, '') + '/checkout'; };
    if (!itemsToReplaceCart) { go(); return Promise.resolve(true); }
    return RT.cart.clear()
      .then(function () { return json((RT.routes.cartAdd || '/cart/add') + '.js', { method: 'POST', body: JSON.stringify({ items: itemsToReplaceCart }) }); })
      .then(function () { go(); return true; })
      .catch(function (err) {
        if (overlay) overlay.classList.remove('is-active');
        console.error(err);
        alert('Could not start checkout. Please try again.');
        return false;
      });
  };
  window.addEventListener('pageshow', function () {
    var overlay = doc.querySelector('[data-checkout-overlay]');
    if (overlay) overlay.classList.remove('is-active');
  });

  /* ---------------------------------------------------------------- init */
  function init(scope) {
    RT.initReveal(scope);
    RT.initAccordions(scope);
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
